import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { DEFAULT_LOCALE } from './config/build'

// ── uni API 兼容层（必须最先挂载，页面/组件中使用的 uni.xxx 依赖此全局对象）──
import uni from './utils/uni'
window.uni = uni
// getCurrentPages 也挂到 window，供组件直接调用
import { getCurrentPages } from './utils/uni'
window.getCurrentPages = getCurrentPages
import { registerUniLifecycleCompat } from './utils/uni-lifecycle'
registerUniLifecycleCompat(Vue)

// ── Vant ─────────────────────────────────────────────────────────────────────
import Vant, { Notify, Toast, Dialog, Lazyload } from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.use(Notify)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Lazyload)

// ── 自定义主题 ────────────────────────────────────────────────────────────────
import './styles/bisor.scss'

// ── VueSlider ─────────────────────────────────────────────────────────────────
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)

import LuckDraw from 'vue-luck-draw'
Vue.use(LuckDraw)

// ── vue-clipboard2 ────────────────────────────────────────────────────────────
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// ── i18n ─────────────────────────────────────────────────────────────────────
import VueI18n from 'vue-i18n'
import messages from './locale'
Vue.use(VueI18n)

const persistedLocale =
  uni.getStorageSync('lang') || uni.getStorageSync('language') || DEFAULT_LOCALE
uni.setStorageSync('lang', persistedLocale)

const i18n = new VueI18n({
  locale: persistedLocale,
  messages,
  silentTranslationWarn: true
})

// 将 i18n 挂到 uni，供 store 中 uni.$i18n.t() 调用
uni.$i18n = i18n

// ── 全局 API ──────────────────────────────────────────────────────────────────
import api from './request'
Vue.prototype.$api = api

// ── 全局工具方法 ──────────────────────────────────────────────────────────────
import colortext from './components/colortext'
Vue.use(colortext)

Vue.prototype.$numFormat = (num, digits) => {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e4, symbol: 'W' }
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) break
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

Vue.prototype.filterNumer = (val, n = 2) => {
  if (!val) return '0.00'
  const v = Math.pow(10, n)
  return (Math.round(val * v) / v).toFixed(n) || 0
}

Vue.prototype.$returnBack = () => {
  const pages = getCurrentPages()
  if (pages && pages.length > 1) {
    uni.navigateBack({ delta: 1 })
  } else {
    history.back()
  }
}

Vue.prototype.$filterMoney = (money, locales = 'en-US', digits) => {
  try {
    if (money || money === 0) {
      const currencyMap = {
        'en-IN': { currency: 'INR', minimumFractionDigits: 2 },
        'ko-KR': { currency: 'KRW', minimumFractionDigits: 0 },
        'en-US': { currency: 'USD', minimumFractionDigits: 2 },
        zh:      { currency: 'CNY', minimumFractionDigits: 2 },
        'de-DE': { currency: 'EUR', minimumFractionDigits: 2 },
        'fr-FR': { currency: 'EUR', minimumFractionDigits: 2 },
        'jp-JP': { currency: 'JPY', minimumFractionDigits: 0 },
        'th-TH': { currency: 'THB', minimumFractionDigits: 2 }
      }
      const { currency, minimumFractionDigits } = currencyMap[locales] || currencyMap['en-US']
      return Number(money).toLocaleString(locales, {
        style: 'currency',
        currency,
        minimumFractionDigits: digits !== undefined ? digits : minimumFractionDigits
      }) || '0'
    }
  } catch (e) { /* ignore */ }
}

Vue.prototype.$langList = [
  { code: 'en', name: 'English' },
  { code: 'cn', name: '中文' },
  { code: 'pt', name: 'Português' }
]

// ── 启动 ───────────────────────────────────────────────────────────────────────
Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

// Keep a visible, signed-in page in the five-minute online window.
// The login endpoint itself records the first activity timestamp.
let lastHeartbeatAt = 0
const heartbeat = () => {
  if (document.visibilityState !== 'visible' || !localStorage.getItem('token')) return
  const now = Date.now()
  if (now - lastHeartbeatAt < 60 * 1000) return
  lastHeartbeatAt = now
  api.heartbeat().catch(() => {})
}
window.setInterval(heartbeat, 2 * 60 * 1000)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') heartbeat()
})

// 初始化 socket 连接 & 登录检查
// store.dispatch('startLoginCheck')
